import { cmsCLient } from '@/services/axiosConfig'
import { GetCoorperationPageRes } from './types'

export type GetCooperationPageData = () => Promise<GetCoorperationPageRes>

export const getCooperationPageData: GetCooperationPageData = async () => {
  try {
    const response = await cmsCLient.get('/cooperation-page')
    return response.data
  } catch (e: any) {
    return e.message
  }
}
